import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import {
  Container,
  Title,
  Alert,
  Text
} from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import ProductManagement from '../../components/seller/ProductManagement';
import { api } from '../../services/api';

const SellerProducts = () => {
  const { isAuthenticated, user } = useSelector(state => state.auth);
  const [sellerProfile, setSellerProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAuthenticated && user?.is_seller) {
      fetchSellerProfile();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, user]);

  const fetchSellerProfile = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.get('/princesses/profile/');
      setSellerProfile(response.seller_profile);
    } catch (err) {
      console.error('Error fetching seller profile:', err);
      setError(err.response?.data?.error || 'Failed to load princess profile');
    } finally {
      setLoading(false);
    }
  };

  // Redirect if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Show message if not a seller
  if (!user?.is_seller) {
    return (
      <Container size="lg" py="xl">
        <Alert 
          icon={<IconExclamationCircle size="1rem" />} 
          color="blue" 
          title="Princess Access Required"
        >
          <Text>
            You need to be a registered princess to access this page. 
            Please register as a princess first to start listing products.
          </Text>
        </Alert>
      </Container>
    );
  }

  return (
    <Container size="xl" py="xl">
      <Title order={1} mb="xl">My Products</Title>
      
      {error && (
        <Alert 
          icon={<IconExclamationCircle size="1rem" />} 
          color="red" 
          mb="xl"
        >
          {error}
        </Alert>
      )}

      {sellerProfile && (
        <ProductManagement 
          sellerProfile={sellerProfile}
          canSell={sellerProfile.can_sell}
        />
      )}
    </Container>
  );
};

export default SellerProducts;